module.exports = __webpack_public_path__ + "static/media/sports_8.2888be97.jpg";